@if (data) {
  <section>
    @if (isDefaultChart()) {
      <mat-checkbox [(ngModel)]="data.showSettings" data-cy="dashboard-graph-show-settings">
        {{ 'DASHBOARD.GRAPH_SHOW_SETTINGS' | translate }}
      </mat-checkbox>
    }
  </section>
  <section>
    <app-emu-input
      data-cy="dashboard-graph-name"
      name="{{ 'DASHBOARD.GRAPH_NAME' | translate }}"
      placeholder="{{ 'DEFAULT' | translate }}"
      [(value)]="data.name"
      (valueChange)="refreshSeries()"
      [className]="'dashboard-settings'"
    ></app-emu-input>
  </section>
  <section>
    <app-emu-list-input
      data-cy="dashboard-graph-type"
      [(value)]="data.type"
      [name]="'DASHBOARD.GRAPH_TYPE'"
      (optionSelected)="reloadGraph()"
      [clearButtonHidden]="true"
      [filteredOptions$]="of(graphTypes)"
      [className]="'dashboard-settings'"
    >
      <ng-template let-item
        ><p>{{ getTypeString(item) | translate }}</p></ng-template
      >
    </app-emu-list-input>
  </section>
  <section>
    <app-emu-list-input
      data-cy="dashboard-graph-range"
      [(value)]="data.userDefinedRange"
      [name]="'DASHBOARD.GRAPH_RANGE'"
      (optionSelected)="rangeHasChanged(); reloadGraph()"
      [clearButtonHidden]="true"
      [filteredOptions$]="of(getDefinedRanges())"
      [className]="'dashboard-settings'"
    >
      <ng-template let-item
        ><p>{{ getRangeString(item) | translate }}</p></ng-template
      >
    </app-emu-list-input>
    @if (data.userDefinedRange === DataDisplayDefaultRanges.CUSTOM) {
      <!--        [disabled]="rangePickDisabled"-->
      <app-range-picker [currentRange]="getRange()" (rangeHasChanged)="changeRange($event)">
      </app-range-picker>
    }
  </section>
  @if (isDefaultChart()) {
    <section>
      <app-scale-settings
        data-cy="dashboard-graph-scale-settings"
        [(value)]="data.scale"
        (valueChange)="reloadGraph()"
        [className]="'dashboard-settings'"
        [rangeInHours]="getRangeInHours()"
      ></app-scale-settings>
    </section>
  }
  <section>
    @if (isPiechart()) {
      <mat-checkbox
        [(ngModel)]="data.doughnut"
        (change)="refreshSeries()"
        data-cy="dashboard-checkbox-doughnut"
      >
        {{ 'DASHBOARD.DOUGHNUT' | translate }}
      </mat-checkbox>
    }
  </section>
  @if (isSankey()) {
    <app-sankey-chart-config [data]="data"></app-sankey-chart-config>
  } @else {
    <section>
      @defer {
        <app-graph-settings-series
          [data]="data"
          [forceConsumption]="forceConsumption()"
          [showConsumption]="showConsumption()"
          [showColor]="isColorConfigurable()"
        ></app-graph-settings-series>
      } @placeholder (minimum 100ms) {
        <app-skeleton></app-skeleton>
      }
    </section>
  }
}
